import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { cn } from "@/lib/utils";

export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.resolvedLanguage?.startsWith("th") ? "th" : "en";

  const toggleLanguage = (lang: "en" | "th") => {
    void i18n.changeLanguage(lang);
  };

  return (
    <div className={cn("inline-flex items-center rounded-full border border-ink/25 bg-transparent p-0.5 text-xs", className)}>
      <Languages className="ml-1.5 mr-1 size-3.5 text-muted" aria-hidden="true" />
      <button
        type="button"
        onClick={() => toggleLanguage("en")}
        className={cn(
          "rounded-full border border-transparent px-1.5 py-0.5 transition-colors pointer-coarse:min-h-11 pointer-coarse:min-w-11 focus-visible:border-focus focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-focus",
          currentLang === "en" ? "bg-ink font-semibold text-canvas" : "font-normal text-muted hover:text-ink",
        )}
        aria-label="Switch to English"
        aria-pressed={currentLang === "en"}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => toggleLanguage("th")}
        className={cn(
          "rounded-full border border-transparent px-1.5 py-0.5 transition-colors pointer-coarse:min-h-11 pointer-coarse:min-w-11 focus-visible:border-focus focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-focus",
          currentLang === "th" ? "bg-ink font-semibold text-canvas" : "font-normal text-muted hover:text-ink",
        )}
        aria-label="เปลี่ยนเป็นภาษาไทย"
        aria-pressed={currentLang === "th"}
      >
        TH
      </button>
    </div>
  );
}
